import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import FileExplorerComponent from '../dashboard/FileExplorerComponent';

function FileExplorerView() {
  return (
    <MainLayout>
      <FileExplorerComponent />
    </MainLayout>
  );
}

export default FileExplorerView;
